<template>
  <modal :show="show" @change="$emit('change', $event)" width="400">
    <template v-slot:header>
      <span></span>
    </template>
    <template v-slot:main>
      <div class="modal-content">
        <div class="tes-text modal-content-text mt-5">
          Информация по лицевому счету не найдена.
          <br />Проверьте корректность введенных данных 
          <br />и повторите попытку.
          <br>
          <v-btn class="orange-button mb-5 mt-5" @click="$emit('change', false)"
            >Повторить попытку</v-btn
          >
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "../common/Modal";
import { mapGetters } from "vuex";

export default {
  name: "ModalReadingsInfo",
  components: { Modal },
  model: {
    prop: "show",
    event: "change",
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("locale",["currentLocale"]),
  },
  methods: {},
  created() {},
  watch: {},
};
</script>

<style lang="scss">
.modal-content-text {
  text-align: center;
  padding: 10px;
}
</style>

<style lang="scss">
.modal-content-text {
  text-align: center;
  padding: 10px;
}
</style>